<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  title="{{
    (mode === planType.Backup ? 'shared:computers.modals:deletePlanCaption' : 'shared:computers.modals.deleteRestorePlanCaption') | i18next
  }}"
  #modal>
  <div modal-body>
    <ng-container *ngIf="mode === planType.Restore; else backup">
      <mbs-alert
        [type]="alertType.warning"
        [icon]="true"
        class="mb-0">
        {{ 'shared:computers.modals.deletePlanQuestion' | i18next }}&nbsp;&ldquo;<span class="fw-semibold">{{ plan?.displayName }}</span
        >&rdquo;?
      </mbs-alert>
    </ng-container>

    <ng-template #backup>
      <div class="mb-3">{{ 'shared:computers.modals.youAreAboutToDelete' | i18next }}</div>

      <mbs-form-group>
        <h5 class="mt-0 mb-2">{{ 'shared:common.backupPlan' | i18next }}</h5>
        <div>{{ plan.displayName }}</div>
      </mbs-form-group>
    </ng-template>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="danger"
      [loading]="loading"
      (click)="handleResolve()">
      {{ 'shared:buttons.delete' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
